 <!-- ProjectComponent.vue -->
<template>
  <div>

    <div class="dark:rounded info bg-trader-gray">
      <div class="Navigation-container ">

        <div class="overview">
          <span>{{ $t('app.project.navigation.page') }}:</span> <span class="bold">{{ pageNumber }}</span>
        </div>

        <div class="overview">
          <span>{{ $t('app.project.navigation.document') }}:</span> <span class="bold">{{ magazineName }}</span>
        </div>

        <div class="overview">
          <span>{{ $t('app.project.navigation.project') }}:</span> <span class="bold">{{ projectName }}</span>
        </div>

        <div class="overview">
        </div>

        <div class="overview pr-1">
          <select class="chooseProjects" v-model="selectedProjectId" @change="openProject(selectedProjectId) ">
            <option :value="0">Projects</option>
            <option v-for="project in projects" :key="project.projectId" :value="project.projectId">
              {{ project.projectName }}
            </option>
          </select>
        </div>
      </div>
    </div>


    <div v-if="selectedProjectId === 0">

      <div class="projects electron:px-2 mt-4">
        <template v-for="project in projects" :key="project.projectId">
          <div :data-ui="project.projectName" @click="openProject(project.projectId)" class="parent dark:rounded"
               :class="[highlightedProjects[project.projectId]?.highlight == true ? 'bg-trader-red text-trader-dark-red' : project.lock ? 'bg-trader-orange text-trader-dark-orange' : 'bg-trader-darker-gray dark:bg-trader-dark-gray text-white dark:px-2']">
            {{ project.projectName }}
          </div>


        </template>
        <div style="clear: both !important; float: none !important;"></div>
      </div>


    </div>
    <div v-else>

      <div class="projects  electron:px-2 mt-4">

        <div class="parent back bg-trader-darker-gray text-white dark:rounded dark:text-trader-lighter-gray" @click="goBack()">&lt;</div>
        <template v-if="magazines !== null" v-for="magazine in magazines" :key="magazine.magazineId">

          <div  :data-ui="'magazine-' + magazine.magazineName" class="parent dark:rounded"
               :class="[highlightedMagazines[magazine.magazineId]?.highlight == true ? 'bg-trader-red text-trader-dark-red ' : magazine.lock == true ? 'bg-trader-orange text-trader-dark-orange' : 'bg-trader-darker-gray text-white']">
            {{ magazine.magazineName }}
          </div>

          <div v-for="page in magazine.pages" :key="page.pageId"
               class="page dark:rounded "
               :data-ui="'page-number-' + page.pagePosition"
               :title="page.pageName ? 'Seitenname: ' + page.pageName : ''"
               :class="[ highlightedMagazines[magazine.magazineId]?.pages?.[page.pagePosition]?.highlight == true ? 'bg-trader-red text-trader-dark-red' : this.selectedMagazineId == magazine.magazineId && this.selectedPagePosition == page.pagePosition ? 'bg-trader-blue text-white' : page.lock == true ? 'bg-trader-orange text-trader-dark-orange' :  'bg-trader-dark-gray text-trader-text']"
               @click="openPage(selectedProjectId, magazine.magazineId, page.pagePosition, page.marketId)">
            {{ page.pagePosition }}
          </div>

        </template>

        <div style="clear: both !important; float: none !important;"></div>
      </div>
    </div>
  </div>
</template>

<script>
import {gql} from "@apollo/client/core";
import apolloClient from "../../apolloClient";
import router from "@/router";
import db from "../../application/db";
import SignalBus from "@/application/SignalBus";

import {highlightedMagazines, highlightedProjects} from "../../application/Highlighter.js";

export default {
props: {
  onCLickReloadPage: {
    type: Function,
    default: () => {}
  },
  view: {
    type: String,
    default: "project"
  }
},
  data() {
    return {
      highlightedMagazines: highlightedMagazines,
      highlightedProjects: highlightedProjects,
      projects: null,
      magazines: null,
      selectedProjectId: 0,
      selectedMagazineId: 0,
      selectedPagePosition: 0,
    }
  },
  computed: {
    projectName() {
      if (this.selectedProjectId === 0) {
        return "";
      } else {
        return this.projects.find(project => project.projectId === this.selectedProjectId)?.projectName || "";
      }
    },
    magazineName() {
      if (this.selectedMagazineId === 0) {
        return "";
      } else {
        try {
          return this.magazines.find(magazine => magazine.magazineId === this.selectedMagazineId).magazineName;
        } catch (error) {
          return "";
        }
      }
    },
    pageNumber() {
      if (this.selectedPagePosition === 0) {
        return "";
      } else {
        try {
          return this.magazines.find(magazine => magazine.magazineId === this.selectedMagazineId).pages.find(page => page.pagePosition === this.selectedPagePosition).pagePosition;
        } catch (error) {
          return "";
        }
      }
    },

  },
  methods: {
    openProject(projectId) {
      router.push('/'+this.view+'/' + projectId );
    },
    getMagazinePagePositions(projectId, magazineId) {
      let pagePositions = [];
      try {
        let magazine = this.projects?.find(project => project.projectId === projectId).magazines.find(magazine => magazine.magazineId === magazineId)?.pages;
        if (magazine) {
          pagePositions = magazine.map(page => page.pagePosition);
        }
      } catch (e) {
        console.error(e);
      }

      this.$store.commit('setMagazinePagePositions', pagePositions || []);
    },
    openPage(projectId, magazineId, pagePosition, marketId) {
      if (this.view == "list" || this.view == "sort"){
        router.push('/'+this.view+'/' + projectId + "/" + magazineId + "/" + pagePosition + "/" + marketId );
      }else{
        router.push('/'+this.view+'/' + projectId + "/" + magazineId + "/" + pagePosition + "/" + marketId + "/null");
      }
    },
    goBack() {

      this.selectedProjectId = 0;
      this.magazines = null;
      router.push('/'+ this.view+ '/');
      this.onCLickReloadPage();

    },
    async getProjectsForCurrentUser() {
      const {data} = await apolloClient.query({
        query: gql`
          query GetProjectsForCurrentUser{
            getProjectsForCurrentUser{
                projectName
                projectId
                lock
              magazines {
                magazineId
                magazineName
                lock
                pages {
                  pageId
                  pageName
                  pagePosition
                  lock
                  marketId
                }
              }
            }
          }
        `,
        variables: {}
      });

      this.projects = data.getProjectsForCurrentUser;
    },
  },

  async mounted() {

  },
  async created() {
    await this.getProjectsForCurrentUser();


    if(this.$isParamDefined('projectId')){
      this.selectedProjectId = parseInt(this.$route.params.projectId);

      if (isNaN(this.selectedProjectId) || this.selectedProjectId === undefined || this.selectedProjectId === null || this.selectedProjectId === 0) {
        this.selectedProjectId = 0;
      } else {
        this.magazines = this.projects.find(project => project.projectId === this.selectedProjectId)?.magazines || null;
      }
    }

    if(this.$isParamDefined('magazineId')){
      this.selectedMagazineId = parseInt(this.$route.params.magazineId);

      if (isNaN(this.selectedMagazineId) || this.selectedMagazineId === undefined || this.selectedMagazineId === null || this.selectedMagazineId === 0) {
        this.selectedMagazineId = 0;
      }
    }

    if(this.$isParamDefined('pagePosition')){
      this.selectedPagePosition = parseInt(this.$route.params.pagePosition);

      if (isNaN(this.selectedPagePosition) || this.selectedPagePosition === undefined || this.selectedPagePosition === null || this.selectedPagePosition === 0) {
        this.selectedPagePosition = 0;
      }
    }

    this.getMagazinePagePositions(this.selectedProjectId, this.selectedMagazineId);
  },
  watch: {
    '$route.params.projectId': function (value) {
      this.selectedProjectId = parseInt(value);

      if (isNaN(this.selectedProjectId) || this.selectedProjectId === undefined || this.selectedProjectId === null || this.selectedProjectId === 0) {
        this.selectedProjectId = 0;
      } else {
        this.magazines = this.projects.find(project => project.projectId === this.selectedProjectId).magazines;
      }
    },
    '$route.params.magazineId': function (value) {
      this.selectedMagazineId = parseInt(value);
      this.getMagazinePagePositions(this.selectedProjectId, this.selectedMagazineId);

      if (isNaN(this.selectedMagazineId) || this.selectedMagazineId === undefined || this.selectedMagazineId === null || this.selectedMagazineId === 0) {
        this.selectedMagazineId = 0;
      }
    },
    '$route.params.pagePosition': function (value) {
      this.selectedPagePosition = parseInt(value);

      if (isNaN(this.selectedPagePosition) || this.selectedPagePosition === undefined || this.selectedPagePosition === null || this.selectedPagePosition === 0) {
        this.selectedPagePosition = 0;
      }
    },

  }
}
</script>


<style scoped>

.project-navigation {
  margin-bottom: 10px;
}



.info span {
  line-height: 25px;
  margin: 0px 5px;
}


.parent,
.page {
  min-height: 25px;
  min-width: 25px;
  margin-right: 2px;
  margin-bottom: 2px;
  line-height: 25px;
  text-align: center;
  float: left;
}

.back {
  background: #646464;
}

.parent {
  padding-right: 5px;
  padding-left: 5px;
}


.page.lock {
  background: #f8cb84;
  color: #b57006;
}

.page.selected {
  background: #576b80;
  color: white;
}

.parent:hover,
.page:hover {
  background: #576b80;
  color: white;
  cursor: pointer;

}

.bold {
  font-weight: bold;
}

.chooseProjects {
  margin-top: 4px;
  border: 0;
}


.Navigation-container {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-content: stretch;
  align-items: flex-start;
}

.overview:nth-child(1) {
  order: 0;
  flex: 0 1 auto;
  align-self: auto;
}

.overview:nth-child(2) {
  order: 0;
  flex: 0 1 auto;
  align-self: auto;
}

.overview:nth-child(3) {
  order: 0;
  flex: 0 1 auto;
  align-self: auto;
}

.overview:nth-child(4) {
  order: 0;
  flex: 1 1 auto;
  align-self: auto;
}

.overview:nth-child(5) {
  order: 0;
  flex: 0 1 auto;
  align-self: auto;
}
</style>
